import { Mouse } from 'lucide-react';
import React, { useEffect, useState } from 'react';

const ScrollDownIndicator = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const scrollContainer = document.querySelector(
      '#ticket-categories-container',
    )!;

    const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
    setIsVisible(scrollHeight - scrollTop - clientHeight > 20);
  };

  useEffect(() => {
    const scrollContainer = document.querySelector(
      '#ticket-categories-container',
    )!;

    const resizeObserver = new ResizeObserver(() => {
      handleScroll();
    });

    for (const child of Array.from(scrollContainer.children)) {
      resizeObserver.observe(child);
    }

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    const scrollContainer = document.querySelector(
      '#ticket-categories-container',
    )!;

    scrollContainer.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="w-full flex items-center justify-center gap-1 absolute bottom-0 pt-12 bg-gradient-to-t from-neutral-0/90 to-transparent to-opacity-0 text-neutral-800">
      <Mouse size={20} className="animate-bounce" />
      <p className="p1-medium">Scroll for more</p>
    </div>
  );
};

export default ScrollDownIndicator;
